module.exports = __webpack_public_path__ + "img/codes.2ed6a35a.svg";